<template>
  <header id="header">
    <h1>{{title}}</h1>
    <div class="menu">
      <a href class="home" @click.prevent="home">
        <img src="@/assets/img/home.png" alt="홈" />
      </a>
      <a href="#" v-if="!hasTimeTable" title="메뉴" @click.prevent="toggleGnb">
        <img src="@/assets/img/menu.png" alt="메뉴" />
      </a>
      <a href="#" v-if="hasTimeTable" title="메뉴" @click.prevent="timetable">
        <img src="@/assets/img/ttable.png" alt="메뉴" />
      </a>
    </div>
  </header>
</template>

<script>
export default {
  props: ["title"],
  methods: {
    toggleGnb: function() {
      this.$store.dispatch("toggleGnb");
    },
    home() {
      this.$router.push("/main");
    },
    timetable() {
      this.$router.push("/timetable");
    }
  },
  computed: {
    hasTimeTable() {
      return this.$store.state.hasTimeTable;
    }
  }
};
</script>


<style lang="scss" scoped>
</style>